import React, { useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { apiService } from '../services/api';
import './FreePlanQRPage.css';

interface FreePlanPageProps {
  onLogout: () => void;
}

const FreePlanPage: React.FC<FreePlanPageProps> = ({ onLogout }) => {
  // Generate universal SMS QR code - works on all devices (iPhone, Android, etc.)
  const qrCodeUrl = 'sms:+16288679755?body=hi';

  // Check authentication on mount and redirect if not logged in
  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Try to fetch user profile to verify authentication
        await apiService.getCurrentUser();
      } catch (error) {
        // If auth check fails, redirect to login
        console.log('❌ Not authenticated, redirecting to login');
        window.location.href = '/login';
      }
    };

    checkAuth();
  }, []);

  // Detect browser back button and logout
  useEffect(() => {
    const handlePopState = () => {
      console.log('🔙 Browser back detected from /free-plan - logging out');

      // Logout (clears cookie)
      onLogout();

      // Redirect to login page with full reload
      // This ensures even if user presses forward, they're still logged out
      window.location.href = '/login';
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [onLogout]);

  const handleStartTrial = async () => {
    // Redirect directly to Stripe payment link
    window.location.href = 'https://buy.stripe.com/eVq00ibFu0RB82Rd5E1Jm00';
  };

  return (
    <div className="free-plan-qr-page">
      <div className="free-plan-qr-card">
        <h1 className="free-plan-title">🎉You are on the Free Plan with Limited Features</h1>
        <p className="free-plan-subtitle">
          Scan the QR code to start chatting with Remi.
        </p>
        <p className="free-plan-subtitle">
          You can now: set reminders, take notes about people and get daily summaries
        </p>

        <div className="free-plan-qr-container">
          <QRCodeSVG
            value={qrCodeUrl}
            size={256}
            level="H"
            includeMargin={true}
            className="free-plan-qr-image"
          />
        </div>

        <p className="free-plan-description">
          Upgrade to the Standard Plan where you get LinkedIn insights and full platform access.
        </p>

        <button
          className="free-plan-trial-button"
          onClick={handleStartTrial}
        >
          Upgrade - 14 day free trial for Standard Plan
        </button>
      </div>
    </div>
  );
};

export default FreePlanPage;

